import { cn } from "@heroui/theme";
import { formatNumber } from "~/utils/formatters";

export const XPChip = ({
  xp,
  totalXP,
  className,
}: {
  xp: number;
  totalXP?: number;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        "rounded-full min-w-20 border-2 border-white/30 text-white/30 flex flex-row justify-center items-center text-sm px-3",
        className
      )}
    >
      {formatNumber(xp)} XP {totalXP && `/ ${formatNumber(totalXP)} XP`}
    </div>
  );
};
